export const LIST_DEFINITIONS = {
    ACCESS_GROUP: "accessGroup",
    USER: "user",
    USER_NAME: "userName",
    MEMBERSHIP: "membership",
    LOOKUP: "lookup",
    JOB_STATUS: "jobStatus",
    JOB_TYPE: "jobType",
    CONTACT_TYPE: "contactType",
    LOOKUP_TYPE: "lookupType",
    CONTACT: "contact",
    CONTACT_ALL: "contact_all"
};



// WEBPACK FOOTER //
// ./src/vas/controls/list-picker/list-definition.ts